<template>
  <div class="wrap" :class="!isRgba_1 ? 'rgbaColor' : ''">
    <img class="wrapLogo" src="https://p4.ssl.qhimg.com/t01b5a1bb5fed76f084.png" alt="" />
    <ul class="wrapList">
      <li class="wrapListLi" v-for="item in menu" :key="item.key" @click="fetch(item.key)">
        <a :href="item.herf"> {{ item.title }}</a>
      </li>
    </ul>
  </div>
  <!-- <div v-if="isShowBanner" class="banner">
    <img :src="bannerData.img" :alt="bannerData.company" @click="toJump(bannerData.url)" />
    <div class="bannerClose" @click="closeBanner()">
      <close-outlined />
    </div>
  </div> -->
</template>

<script setup>
import { useStore } from '@/store/2023/isc.js'
// import { getHeadLineBanner } from '@/api/2023/index.js'
import { ref } from 'vue'
// import { CloseOutlined } from '@ant-design/icons-vue'
const isRgba_1 = ref(false)
// const bannerData = ref({})
// const isShowBanner = ref(false)
// 监听浏览器滚动条
window.onscroll = function () {
  if (!window.pageYOffset) isRgba_1.value = true //滚动条滚动时
  else isRgba_1.value = false
}
const store = useStore()
const menu = [
  {
    key: 'about',
    title: '关于大会',
    herf: '#about'
  },
  {
    key: 'active',
    title: '最新活动',
    herf: '#active'
  },
  {
    key: 'news',
    title: '新闻中心',
    herf: '#news'
  },
  {
    key: 'review',
    title: '往届回顾',
    herf: '#review'
  }
]

// onMounted(() => {
//   fetchBanner()
//   setTimeout(() => {
//     closeBanner()
//   }, 15000)
// })

// function closeBanner() {
//   isShowBanner.value = false
// }

// function toJump(link) {
//   if (link) {
//     window.open(link, '_blank')
//   }
// }
function fetch(newKey) {
  store.changeKey(newKey)
}

// function fetchBanner() {
//   getHeadLineBanner()
//     .then((res) => {
//       console.log('res', res.data.data)
//       const { data } = res.data
//       if (Object.keys(data).length) {
//         bannerData.value = data
//         isShowBanner.value = true
//       }
//       return
//     })
//     .catch((err) => {
//       console.log('err', err)
//     })
// }
</script>

<style lang="scss" scoped>
.rgbaColor {
  background: rgba(0, 104, 83, 1) !important;
}
.wrap {
  position: fixed;
  top: 0px;
  width: 100%;
  height: 68px;
  background: rgba(0, 104, 83, 0.6);
  backdrop-filter: blur(46.24px);
  padding: 10px 40px;
  z-index: 999;
  &Logo {
    width: 123px;
    height: 48px;
    padding: 4px;
  }
  &List {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    list-style-type: none;
    &Li {
      display: inline-block;
      font-size: 18px;
      line-height: 32px;
      margin-right: 60px;
      font-weight: bold;
      cursor: pointer;
      a {
        color: #ffffff;
      }
    }
  }
}
.banner {
  position: fixed;
  top: 68px;
  width: 100%;
  height: 150px;
  z-index: 10;
  background-color: #fff;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }
  &Close {
    position: absolute;
    right: 15px;
    top: 15px;
    color: #999999;
  }
}
</style>
